export default "__VITE_ASSET__KMUNOjiu__"